<div class="panel-container" *ngFor="let hoodline of hoodlines; let i = index">
  <mat-expansion-panel
    [expanded]="isOpen(openHoodLines$ | async, hoodline.Id)"
    (opened)="expand(hoodline.Id)"
    (closed)="collapse(hoodline.Id)"
    class="line-panel"
    [ngClass]="{ even: i % 2 === 0, odd: i % 2 !== 0 }"
  >
    <mat-expansion-panel-header>
      <mat-panel-title>
        <div class="line-title">
          <b>{{ 'UI.Common.ConfigureHoodConfiguration' | translate }} for {{ hoodline.Properties.Name['Value'] }}</b>
          <app-message-icon *ngIf="hasMessages(hoodline, feedbackMessages$ | async, 0)" [messageLevel]="0"></app-message-icon>
          <app-message-icon *ngIf="hasMessages(hoodline, feedbackMessages$ | async, 1)" [messageLevel]="1"></app-message-icon>
          <app-message-icon *ngIf="hasMessages(hoodline, feedbackMessages$ | async, 2)" [messageLevel]="2"></app-message-icon>
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <p>
      <app-entity-editor
        *ngIf="hoodline && initialized"
        class="cf-fill"
        [entity]="projectEntity && hoodline"
        (propertyChange)="propertyChanged($event, hoodline.Id)"
      ></app-entity-editor>
    </p>
    <div class="cf-flex-row cf-justify-content-end"></div
  ></mat-expansion-panel>
  <button
    data-test="deleteButton"
    matSuffix
    class="ac-table-button delete-button"
    mat-icon-button
    disableRipple="true"
    aria-label="Delete hood line"
    (click)="deleteLine(hoodline.Id)"
    [matTooltip]="'UI.Common.Action.Delete' | translate"
    matTooltipPosition="above"
  >
    <mat-icon svgIcon="delete"></mat-icon>
  </button>
</div>
